





























































import { Vue, Component } from 'vue-property-decorator';
import * as api from '@/api';
import { PaginationMixin } from '@/utils/mixin';
import { State } from 'vuex-class';

import VueClipboards from 'vue-clipboards';

import axios from 'axios';
Vue.use(VueClipboards);

/**
 * rg模板列表
 *
 * @author xiaokunyu
 * @date 03/28/2019
 */
@Component
export default class SpaceTemplateCustom extends PaginationMixin {
    @State(state => state.cti.permission.rg_template)
    permission: boolean;

    templateList: any = [];
    templatePermissionVisible: boolean = false;
    currentTemplate: number = 0;

    spaceId: number = 0;
    tableLoading: Boolean = true;
    $mtd: any;

    templateId: number = 0;
    hoverContent: string = '';

    mounted() {
        this.spaceId = parseInt(this.$route.params.id as string, 10);
        this.getSpaceTemplate();
    }
    async getSpaceTemplate() {
        this.tableLoading = true;
        try {
            const res = await api.spaceApi.getSpaceTemplate({
                cn: this.currentPage,
                sn: this.limit,
                spaceId: this.spaceId,
                type: 'CUSTOM'
            });
            const { code, data } = res;
            if (code === 200) {
                this.templateList = data.items;
                this.total = data.tn;
                if (this.total > 0 && !data.items.length) {
                    this.currentPage -= 1;
                    if (this.currentPage <= 0) {
                        this.currentPage = 1;
                    }
                    this.getSpaceTemplate();
                }
                this.templateList = data.items;
            }
        } catch (e) {
            this.templateList = [];
            console.log(e);
        }
        this.tableLoading = false;
    }
    handleChange(current: number, size: number) {
        this.limit = size;
        this.currentPage = current;
        this.getSpaceTemplate();
    }
    handleCopyLink(row) {
        // todo
        return row.copyLink;
    }
    handleCopySuccess() {
        this.$mtd.message.success('复制成功');
    }
    handleExportTemplate(row) {
        axios({
            url: '/api/tt/1.0/file/download/by/custom/form',
            method: 'GET',
            responseType: 'blob',
            params: {
                customFormId: row.id
            }
        })
            .then(response => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `模板“${row.name}”数据下载.xlsx`);
                document.body.appendChild(link);
                link.click();
            })
            .catch(e => e);
    }
    formatOrgs(permissionOrgs) {
        const orgs = permissionOrgs.map(item => {
            return item.orgPath;
        });
        return orgs.join('、');
    }
}
